import React from 'react';
import { Route } from 'react-router-dom';

import { STOInvoicePrintTemplate } from 'pages/sto-print-template/invoice-template';
import { STOSuratPesananPrintTemplate } from 'pages/sto-print-template/surat-pesanan-template';

import {
  STO_PRINT_TEMPLATE_ROUTE_ROOT,
  STO_PRINT_TEMPLATE_ROUTES,
} from './constants';

export const useSTOPrintTemplateRouter = (): React.JSX.Element => (
  <Route path={STO_PRINT_TEMPLATE_ROUTE_ROOT}>
    <Route
      path={STO_PRINT_TEMPLATE_ROUTES.SURAT_PESANAN}
      element={<STOSuratPesananPrintTemplate />}
    />
    <Route
      path={STO_PRINT_TEMPLATE_ROUTES.INVOICE}
      element={<STOInvoicePrintTemplate />}
    />
  </Route>
);
